module.exports = __webpack_public_path__ + "img/jingxuan01.167e851a.png";